<template>
  <div class="cell">
    {{ formattedDisplayTime }}
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    valueMap: { type: Object },
  },
  computed: {
    formattedDisplayTime() {
      return this.valueMap
        ? moment(this.valueMap.seconds * 1000)
            .local()
            .format("YYYY/MM/DD HH:mm")
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
